
<template>
  <div class="user-dropdown">
    <div class="user-button">
      <span class="d-none d-sm-block user-name" v-text="userContext != null ? userContext.login : ''"></span>
      <div class="user-dropdown-img">
        <img v-if="userContext.photo == null" src="../../assets/profile.png" alt="usuário">
        <img v-else :src="`${userContext.photo}`" alt="usuário">
      </div>
      <i class="fa fa-angle-down icon-down"></i>
    </div>
    <div class="user-dropdown-content">
      <a href="#" @click="logout">
        <i class="fa fa-sign-out"></i> Sair
      </a>
    </div>
  </div>
</template>

<script>

//variaveis vuex
import { mapState } from 'vuex';
//variaveis globais
import { baseApiUrl } from "@/global";
//eventos
import { EventBusLogged } from "@/eventBus/eventBusLogged";

export default {
  name: "UserDropDoewn",
  computed: mapState(["userContext"]),
  data() {
    return {
      url: baseApiUrl
    }
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      this.$router.push({ name: "home" });
      EventBusLogged.$emit("refreshLogged");
    }
  }

};
</script>

<style>
.user-dropdown {
  position: relative;
  height: 100%;
}

.user-button {
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 100;
  height: 100%;
  padding: 0px 20px;
}

.user-name {
  font-family: Arial, Helvetica, sans-serif;
  color: #fff;
  font-size: 18px;
}

.user-dropdown:hover {
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.user-dropdown-img {
  margin: 0px 10px;
}

.user-dropdown-img > img {
  max-height: 37px;
  border-radius: 50%;
  width: 35px;
}

.user-dropdown-content {
  position: absolute;
  right: 0px;
  background-color: #f9f9f9;
  min-width: 175px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.user-dropdown:hover .user-dropdown-content {
  visibility: visible;
  opacity: 1;
}

.user-dropdown-content a {
  text-decoration: none;
  color: #000;
  padding: 10px;
}

.user-dropdown-content a:hover {
  text-decoration: none;
  color: #000;
  background-color: #ededed;
}

.icon-down {
color: #fff;
font-size: 20px;
}
</style>
